import { Pagination as MantinePagination, PaginationProps, useMantineTheme } from '@mantine/core';
import { forwardRef } from 'react';
import { usePreferencesStore } from '../../../stores';
import { LINE_HEIGHT_MAP, LETTER_SPACING_MAP } from '../../../hooks/useAccessibilityStyles';

export type GradientVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger';

export interface ThemedPaginationProps extends PaginationProps {
  gradientVariant?: GradientVariant;
}

const Pagination = forwardRef<HTMLDivElement, ThemedPaginationProps>(
  ({ gradientVariant = 'primary', styles, ...rest }, ref) => {
    const theme = useMantineTheme();
    const gradient = theme.other.gradients[gradientVariant];
    const lineSpacing = usePreferencesStore((state) => state.lineSpacing);
    const letterSpacingPref = usePreferencesStore((state) => state.letterSpacing);

    const accessibilityStyles = {
      lineHeight: LINE_HEIGHT_MAP[lineSpacing],
      letterSpacing: LETTER_SPACING_MAP[letterSpacingPref],
    };

    return (
      <MantinePagination
        ref={ref}
        styles={{
          ...styles,
          control: {
            '&[data-active]': {
              backgroundImage: `linear-gradient(135deg, ${gradient.from}, ${gradient.to})`,
              borderColor: gradient.from,
              color: 'white',
            },
            ...accessibilityStyles,
            ...(styles as any)?.control,
          },
        }}
        {...rest}
      />
    );
  }
);

Pagination.displayName = 'Pagination';

export default Pagination;
